/** Apply transient review feedback to every DOM fragment of an instance. */
export const useSetInstanceError = (
  quill: { root?: HTMLElement },
  attribute: string | undefined,
  instanceId: string | undefined,
  hasError = true
) => {
  if (!quill.root || !attribute || instanceId == undefined) return;

  // Compare IDs directly so IDs containing quotes remain safe to match.
  const elements = Array.from(
    quill.root.querySelectorAll<HTMLElement>(`[${attribute}]`)
  ).filter((element) => element.getAttribute(attribute) === instanceId);

  for (const element of elements) {
    element.classList.remove("instance-error");
  }

  if (hasError && elements.length > 0) {
    // Restart the existing shake animation when Next is pressed again.
    void quill.root.offsetWidth;
    for (const element of elements) {
      element.classList.add("instance-error");
    }
  }
};
